import React from 'react';
import { Typography } from '@mui/material';
import { Add, KeyboardArrowDown, KeyboardArrowUp } from '@mui/icons-material';
import { CollapserProps } from './CollapserProps';

export const Collapser = ({ isAdd, open }: CollapserProps) => {
	const icon = open ? <KeyboardArrowUp /> : isAdd ? <Add /> : <KeyboardArrowDown />;
	const label = open ? 'Collapse' : isAdd ? 'Add' : 'Expand';
	return <Typography title={label}>{icon}</Typography>;
}
